import { SaveAltOutlined } from '@mui/icons-material';
import { IconButton, TableCell, TableRow, Typography } from '@mui/material';
import type { OrderDto } from '@/types/dtos/orders/response/order.dto';
import { ORDER_STATUS } from '@/types/dtos/orders/response/order.dto';
import { roundToTwoDecimals } from '@/helpers/decimal.helper';
import { format } from 'date-fns';
import useDownloadOrderInvoiceMutation from '@/state/mutations/transactions/use-download-order-invoice';
import { capitalize } from '@/helpers/string.helper';
import { useTranslations } from '@/i18n/use-translations';

export const Row = ({ order }: { order: OrderDto }) => {
  const t = useTranslations();
  const { mutateAsync: downloadOrderInvoiceMutation } = useDownloadOrderInvoiceMutation();

  const handleDownloadInvoice = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    await downloadOrderInvoiceMutation(order.id);
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case ORDER_STATUS.DRAFT:
        return 'error.main';
      default:
        return 'text.primary';
    }
  };

  return (
    <TableRow key={order.id}>
      <TableCell>{format(new Date(order.createdAt), 'dd/MM/yyyy')}</TableCell>
      <TableCell>{t('organization.invoice.typeOrder')}</TableCell>
      <TableCell align="right">€{roundToTwoDecimals(order.totalPriceWithVat).toFixed(2)}</TableCell>
      <TableCell align="right">
        <Typography color={getStatusColor(order.status)}>{capitalize(order.status)}</Typography>
      </TableCell>
      <TableCell align="left">
        <IconButton size="small" onClick={(e) => handleDownloadInvoice(e)}>
          <SaveAltOutlined />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};
